import { Option } from '@/components/atoms/select/types';
import { Facet } from '@/types/entity/facet';
import { Product } from '@/types/entity/product';
import { Category } from '@shared/types/product';
import { Account } from '@/types/entity/account';
import { Discount } from '@/types/entity/discount';
import { Transaction } from '@/types/transaction';
import { PurchaseList } from '@/types/entity/purchase-list';
import { PaymentMethod } from '@/components/organisms/cartV2/types';

export const MAX_CART_ITEMS = 500;

export interface CategoryBreadcrumb {
  name: string;
  link: string;
}

export interface CommonProps {
  products: Product[];
  categories: CategoryListItemProps[];
}

export interface ProductSelectionListProps extends CommonProps {
  category?: Category;
  cartItems?: ProductLineItem[];
  breadcrumb?: CategoryBreadcrumb[];
  facets?: Facet[];
  searchQuery?: string;
  onRefine?: (facet: Facet[]) => void;
  onResetAll?: () => void;
  currentSortValue?: string;
  currentSortVector?: string;
  sortValues?: (Option & { vector: 'asc' | 'desc' })[];
  onSortValueChange?: (sortValue: string, vector: 'asc' | 'desc') => void;
  limit?: number;
  total?: number;
  onLoadMore?: () => void;
  addToCartDisabled?: boolean;
  onAddToCart?: () => Promise<void>;
  onAddToLocalCart?: (productLineItem: ProductLineItem) => void;
}

export type CartProps = CommonProps & {
  isLoading?: boolean;
  isFranchise?: boolean;
  deliveryMode?: string;
  isPreOrder?: boolean;
  label?: string;
  account?: Pick<Account, 'email'>;
  paymentMethods?: Array<PaymentMethod>;
  viewCartDisabled?: boolean;
  quoteRequestDisabled?: boolean;
  checkoutDisabled?: boolean;
  invalidAddressesRequirements?: boolean;
  discountCodes?: Array<Discount & { onRemove?: () => Promise<boolean> }>;
  onAdd?: (sku: string, qty: number, price?: number) => Promise<void>;
  onRemove?: (id: string) => Promise<void>;
  onUpdateQuantity?: (id: string, qty: number, price?: number) => Promise<void>;
  onDiscountRedeem?: (code: string) => Promise<boolean>;
  onClear?: () => Promise<void>;
} & { transaction?: Transaction } & Pick<CartItemProps, 'onAddToNewWishlist'>;

export interface CategoryListItemProps {
  id: string;
  name: string;
  slug: string;
  parentId: string;
  isCommercialOperation?: boolean;
  subCategories: CategoryListItemProps[];
}

export interface ProductLineItem {
  sku: string;
  count: number;
  price: number;
  packaging: number;
  type: string;
}

interface ClassNames {
  moveToWishlist?: string;
}

export interface CartItemProps {
  item: Product & { deleted?: boolean };
  classNames?: ClassNames;
  onUpdateQuantity: (qty: number) => Promise<void>;
  onUndoRemove?: () => Promise<void>;
  onRemove?: () => Promise<void>;
  onAddToNewWishlist?: (
    list: Pick<PurchaseList, 'name' | 'description' | 'store'>,
    sku?: string,
    qty?: number,
  ) => Promise<void>;
}
